import React from 'react'
import clsx from 'clsx'
import NewIcon from '@/components/Shared/Card/NewIcon'
import MyBookshelf from '@/components/Shared/MyBookshelf'
import { formatDateToDisplay } from '@/utility/dateFormat'
import styles from './styles.module.scss'

interface CardHeaderProps {
  articleId: number
  articleLink: string
  openDate: string
  used: string
  articleType: string
}

export default function CardHeader({ articleId, openDate, used }: CardHeaderProps) {
  return (
    <div className={clsx(styles.cardHeaderWrapper, styles[used])}>
      <div className={styles.dateWapper}>
        {used !== 'full-width-card' && <NewIcon articleOpenDate={openDate} />}
        <time className={styles.openDate}>{formatDateToDisplay(openDate)}</time>
      </div>
      <MyBookshelf used={used} articleId={articleId} articlePage={false} />
    </div>
  )
}
